export class ProviderUserConfirmRequest {
  key: string;
}
